<div fxLayout="column" fxLayoutGap="10px" class="content-container" style="position: relative">
  <mat-progress-bar class="default-progress-bar" mode="indeterminate" color="primary" *ngIf="isLoading"></mat-progress-bar>
  <app-grid-filter placeholder="Type '/' to bring up a list of available filters"
                   (selectedItemsChanged)="onSelectedItemsChanged($event)"
                   [selectedItemsChange]="selectedFilterChange"
                   [showFilterButton]="true" (onFilterButtonClicked)="openFilterDialog()"
                   [showDateRange]="true" [defaultDateRange]="dateRangeService.selectedDateRange?.action || 0"
                   [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)">
    <app-filter-row-additional-content>
      <button mat-flat-button color="primary" (click)="openExportDialog()">
        <mat-icon>download</mat-icon>
        Export
      </button>
    </app-filter-row-additional-content>
  </app-grid-filter>

  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
    <mat-card appearance="outlined" fxFlex>
      <mat-card-content>
        <div class="column-chart">
          <app-chart-by-user [data]="userSeriesTotals" [showExpand]="true" chartTitle="Total Calls By Agent" ></app-chart-by-user>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" fxFlex>
      <mat-card-content>
        <div style="height: 375px">
          <app-chart-by-user [data]="userSeriesAvgTotals" [showTimeSeries]="true" [showExpand]="true" chartTitle="Average Talk Time by Agent"></app-chart-by-user>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div fxFlex="auto" style="height: 800px;">
    <app-users-summary-grid #usersSummaryGrid [filterChangeEvent]="filterChangeEvent"></app-users-summary-grid>
  </div>
</div>
